<template>
	<div>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="backBtn mobileMargin-b15">
						<router-link to="/tariffprofiles"
							><p
								class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]"
							>
								<span class="fa-light fa-arrow-left textGrey"></span> Take me back
							</p></router-link
						>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button
								:disabled="!editTariffProfile.name || !editTariffProfile.tenant || loading"
								class="jmiBtn btnLg green"
								@click="save()"
							>
								{{ editTariffProfile.id ? 'Save' : 'Create' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/tariffprofiles')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-lg-offset-3">
					<div class="row margin-b10">
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
							<!-- <p class="textSml textGrey fontHeavy textUppercase">User</p> -->
						</div>
					</div>
					<div class="row margin-b20">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="card detailCard flex flex-col rounded-sm shadow-lg">
								<div class="mx-auto mb-5 w-full">
									<div class="col-sm-12 textCenter">
										<div class="navAvatar margin-b10 flex w-full justify-center">
											<img src="/assets/images/teleflow-logo-black.png" width="200" />
										</div>
									</div>
								</div>
								<div v-if="!loading">
									<div class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">Name</label>
											<FormKit
												v-model="editTariffProfile.name"
												type="text"
												class="form-control"
												placeholder="Name"
												name="Name"
												:validation="'required'"
												validation-visibility="live"
											/>
										</div>
									</div>
									<div
										v-if="
											!editTariffProfile.id &&
											(tenants?.length > 1 || $global.hasUserRole(userRoles, 'reseller'))
										"
										class="mx-auto mb-2 w-full px-2 md:mb-5"
									>
										<div class="formGroup withIcon">
											<label class="textGrey">Tenant</label>
											<select v-model="editTariffProfile.tenant" @change="reloadTariffs">
												<option disabled :value="null">-- Select Tenant --</option>
												<option v-for="t in tenants" :key="t.id" :value="t">
													{{ t.companyName }}
												</option>
											</select>
											<span class="fa-light fa-chevron-down"></span>
										</div>
									</div>
									<div v-if="editTariffProfile.tenant" class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">LCRs</label>
										</div>
										<div class="my-2">
											<button class="fab fabSm green" @click="addLcr()">
												<span class="fa-light fa-plus"></span>
											</button>
										</div>
										<div v-for="(ip, i) in editTariffProfile.lcrList" :key="i" class="mb-2 w-full">
											<div class="flex w-full 2xl:w-2/3">
												<div class="formGroup withIcon h-[36.5px] w-full">
													<select v-model="editTariffProfile.lcrList[i]">
														<option :value="null">-- Select LCR {{ i + 1 }} --</option>
														<option v-for="t in filteredLcrs" :key="t.id" :value="t.id">
															{{ t.name }}
														</option>
													</select>
													<span class="fa-light fa-chevron-down"></span>
												</div>
												<div class="flex gap-1 px-2">
													<div v-if="editTariffProfile.lcrList.length > 1">
														<button class="fab fabSm red" @click="removeLcr(i)">
															<span class="fa-light fa-minus"></span>
														</button>
													</div>
													<div>
														<a
															class="fab fabSm blue"
															:class="{
																disabled:
																	!editTariffProfile.lcrList[i] ||
																	editTariffProfile.lcrList[i] === null
															}"
															:href="
																editTariffProfile.lcrList[i] ||
																!editTariffProfile.lcrList[i] === null
																	? `/lcrs/${editTariffProfile.lcrList[i]}`
																	: 'javascript:void(0);'
															"
															target="_blank"
														>
															<svg
																width="16"
																height="16"
																viewBox="0 0 24 24"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
																	fill="currentColor"
																/>
																<path
																	d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
																	fill="currentColor"
																/>
															</svg>
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div v-if="editTariffProfile.tenant" class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">Tariffs</label>
										</div>
										<div class="my-2">
											<button class="fab fabSm green" @click="addTariff()">
												<span class="fa-light fa-plus"></span>
											</button>
										</div>
										<div
											v-for="(ip, i) in editTariffProfile.tariffList"
											:key="i"
											class="mb-2 w-full"
										>
											<div class="flex w-full 2xl:w-2/3">
												<div class="formGroup withIcon h-[36.5px] w-full">
													<select v-model="editTariffProfile.tariffList[i]">
														<option :value="null">-- Select Tariff {{ i + 1 }} --</option>
														<option v-for="t in filteredTariffs" :key="t.id" :value="t.id">
															{{ t.name }}
														</option>
													</select>
													<span class="fa-light fa-chevron-down"></span>
												</div>
												<div class="flex gap-1 px-2">
													<div v-if="editTariffProfile.tariffList.length > 1">
														<button class="fab fabSm red" @click="removeTariff(i)">
															<span class="fa-light fa-minus"></span>
														</button>
													</div>
													<div>
														<a
															class="fab fabSm blue"
															:class="{
																disabled:
																	!editTariffProfile.tariffList[i] ||
																	editTariffProfile.tariffList[i] === null
															}"
															:href="
																editTariffProfile.tariffList[i] ||
																!editTariffProfile.tariffList[i] === null
																	? `/tariffs/${editTariffProfile.tariffList[i]}`
																	: 'javascript:void(0);'
															"
															target="_blank"
														>
															<svg
																width="16"
																height="16"
																viewBox="0 0 24 24"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
																	fill="currentColor"
																/>
																<path
																	d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
																	fill="currentColor"
																/>
															</svg>
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="margin-b20 flex px-2">
										<div class="col-md-12">
											<ul class="stepBtns">
												<li>
													<button
														:disabled="
															!editTariffProfile.name ||
															!editTariffProfile.tenant ||
															loading
														"
														class="jmiBtn btnLg green"
														@click="save()"
													>
														{{ editTariffProfile.id ? 'Save' : 'Create' }}
													</button>
												</li>
												<li>
													<button
														class="jmiBtn btnLg red"
														@click="routeTo('/tariffprofiles')"
													>
														Close
													</button>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="row margin-b20 center-xs center-md center-lg">
										<div class="loader"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import tariffProfilesApi from '../scripts/tariffprofiles/tariffprofiles.api.js'
import lcrsApi from '../scripts/lcrs/lcrs.api.js'
import tariffsApi from '../scripts/tariffs/tariffs.api.js'
import { router } from '../router'

export default {
	inject: ['user', 'userRoles', 'tenants'],
	data() {
		return {
			editTariffProfile: {
				name: '',
				lcrList: [null],
				tariffList: [null],
				tenant: null
			},
			lcrs: [],
			tariffs: [],
			loading: true
		}
	},

	computed: {
		filteredLcrs() {
			return this.lcrs
				.filter((t) => t.tenant && t.tenant.id === this.editTariffProfile.tenant.id)
				.sort((a, b) => a.name.localeCompare(b.name))
		},
		filteredTariffs() {
			return this.tariffs
				.filter((t) => t.tenant && t.tenant.id === this.editTariffProfile.tenant.id)
				.sort((a, b) => a.name.localeCompare(b.name))
		}
	},

	async created() {
		try {
			const lcrsResults = lcrsApi.getAll()

			if (this.$route.params.id !== 'new') {
				const result = await tariffProfilesApi.getById(this.$route.params.id)
				this.editTariffProfile = result.data
				if (!this.editTariffProfile.lcrList || !this.editTariffProfile.lcrList.length)
					this.editTariffProfile.lcrList = [null]
				if (!this.editTariffProfile.tariffList || !this.editTariffProfile.tariffList.length)
					this.editTariffProfile.tariffList = [null]
			} else if (this.tenants?.length === 1) {
				this.editTariffProfile.tenant = this.tenants[0]
			}

			await this.reloadTariffs()

			this.lcrs = (await lcrsResults).data.results

			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading route',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/tariffprofiles')
			})
			console.error(e)
		}
	},

	methods: {
		async reloadTariffs() {
			if (this.editTariffProfile.tenant?.id) {
				const tariffApiResult = tariffsApi.getAll({
					where: {
						selectedTenant: this.editTariffProfile.tenant?.id
					}
				})

				this.tariffs = (await tariffApiResult).data.results
			}
		},
		removeLcr(i) {
			this.editTariffProfile.lcrList.splice(i, 1)
		},
		addLcr() {
			this.editTariffProfile.lcrList.push(null)
		},
		goToLcr(i) {
			if (this.editTariffProfile.lcrList[i]) {
				window.open('/lcrs/' + this.editTariffProfile.lcrList[i], '_blank')
			}
		},
		removeTariff(i) {
			this.editTariffProfile.tariffList.splice(i, 1)
		},
		addTariff() {
			this.editTariffProfile.tariffList.push(null)
		},
		goToTariff(i) {
			if (this.editTariffProfile.tariffList[i]) {
				window.open('/tariffs/' + this.editTariffProfile.tariffList[i], '_blank')
			}
		},
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			this.editTariffProfile.tariffList = this.editTariffProfile.tariffList.filter((tp) => !!tp)
			this.editTariffProfile.lcrList = this.editTariffProfile.lcrList.filter((lcr) => !!lcr)

			if (!this.editTariffProfile.id) {
				tariffProfilesApi
					.create(this.editTariffProfile)
					.then((u) => {
						this.routeTo('/tariffprofiles')
					})
					.catch(console.error)
			} else {
				tariffProfilesApi
					.update(this.editTariffProfile)
					.then((u) => {
						this.routeTo('/tariffprofiles')
					})
					.catch(console.error)
			}
		}
	}
}
</script>
